import { api } from '../../../services/api/client';
import type { User } from '../../../types';

export interface ProfileUpdate {
  full_name?: string;
  phone?: string;
}

export async function updateProfile(payload: ProfileUpdate): Promise<User> {
  const { data } = await api.put<User>('/auth/profile', payload);
  return data;
}
export async function changePassword(current_password: string, new_password: string): Promise<any> {
  const { data } = await api.post('/auth/change-password', { current_password, new_password });
  return data;
}

export interface EmailPreferences {
  signal: boolean;
  broadcast: boolean;
  promo: boolean;
}

export async function getEmailPreferences(): Promise<EmailPreferences> {
  const { data } = await api.get<EmailPreferences>('/auth/email-preferences');
  return data;
}

export async function updateEmailPreferences(payload: EmailPreferences): Promise<EmailPreferences> {
  const { data } = await api.put<EmailPreferences>('/auth/email-preferences', payload);
  return data;
}
